module.exports = __webpack_public_path__ + "img/icon-bag-en.40167e37.svg";